import React from "react"
import { Warning } from "@mui/icons-material"

const columns = [
  {
    field: 'expiration_date',
    headerName: 'Vencimento',
    flex: 1,
    type: 'date',
    valueFormatter: (params) => {
      if (!(params?.value) || params.value === 'N/A') {
        return 'N/A'
      }
      return params.value.format('DD/MM/yyyy')
    },
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'contract',
    headerName: 'Contrato',
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    type: 'number',
    field: 'value',
    headerName: 'Valor',
    flex: 1,
    renderCell: (params) => {
      const value = params.value.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
      if (!params.row.hasDuplicate) {
        return value
      }
      return (
        <span style={{ display: 'flex', gap: 3 }}>
          {value}
          <Warning color='warning' style={{ fontSize: '1.8rem' }} />
        </span>
      )
    },
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'debtor_type',
    headerName: 'Tipo',
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'creditor',
    headerName: 'Credor',
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'base',
    headerName: 'Base',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
  },
]

export default columns
